// Store associate login uses a 2-digit ID + password (3 letters + 3 numbers).
// Supabase Auth still needs an email — we map IDs to an internal address.

export const STORE_INTERNAL_DOMAIN = "store.ahpickles.in";
export const STORE_USER_ID_RE = /^\d{2}$/;
export const STORE_PASSWORD_RE = /^[A-Za-z]{3}\d{3}$/;

export const STORE_LEGACY_DOMAIN = "associates.ahpickles.internal";

export function storeAssociateInternalEmail(userId) {
  const id = String(userId || "").trim();
  return `store-${id}@${STORE_INTERNAL_DOMAIN}`;
}

export function storeAssociateLegacyEmail(userId) {
  const id = String(userId || "").trim();
  return `store-${id}@${STORE_LEGACY_DOMAIN}`;
}

/** All plausible auth emails for a store associate ID (current + legacy formats). */
export function storeAssociateLoginEmails(userId, resolvedFromDb) {
  const id = String(userId || "").trim();
  const emails = [
    resolvedFromDb,
    storeAssociateInternalEmail(id),
    storeAssociateLegacyEmail(id),
  ].filter(Boolean);
  return [...new Set(emails.map((e) => String(e).trim().toLowerCase()))];
}

export function detectStoreAssociate(user, profile) {
  if (!user || profile?.is_admin) return false;
  // Once the DB profile is loaded it is the single source of truth.
  if (profile) return profile.is_store_associate === true;
  // Profile not loaded yet — fall back only to app_metadata, which can be set
  // exclusively by the service role (admin Edge Functions), never by the client.
  return user.app_metadata?.is_store_associate === true;
}

export function validateStoreUserId(userId) {
  const id = String(userId || "").trim();
  if (!id) return "User ID is required.";
  if (!STORE_USER_ID_RE.test(id)) return "User ID must be exactly 2 digits (e.g. 01).";
  return null;
}

export function validateStorePassword(password, { required = true } = {}) {
  const pw = String(password || "");
  if (!pw) return required ? "Password is required." : null;
  if (!STORE_PASSWORD_RE.test(pw)) return "Password must be 3 letters followed by 3 numbers (e.g. abc123).";
  return null;
}

export function associateStoreStats(associateId, orders) {
  const sales = (orders || []).filter(
    (o) => o.order_source === "store" && o.uid === associateId
  );
  const revenue = sales.reduce((sum, o) => sum + (Number(o.total) || 0), 0);
  return { salesCount: sales.length, revenue };
}
